import { MantineThemeOverride } from '@mantine/core';

export type AnchorTheme = NonNullable<MantineThemeOverride['components']>['Anchor'];

export const Anchor: AnchorTheme = {
  // todo: define
};
